import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { JobArchitectureSkillLimits } from '~/shared/data-contract/job-architecture-skill-limits';

import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';
import { jobArchitectureKeys } from './query-keys';

type UseSkillLimitsOptions = {
    readonly architectureId: string;
    readonly enabled: boolean;
};

export const useSkillLimits = ({
    architectureId,
    enabled,
}: UseSkillLimitsOptions): UseQueryResult<JobArchitectureSkillLimits, Error> => {
    const { fetchSkillLimits } = useApplicationFetchers();

    return useQuery({
        enabled,
        queryFn: async () => {
            const result = await fetchSkillLimits({ jobArchitectureId: architectureId });

            if (result.isErr === true) {
                throw result.error;
            }

            return result.value;
        },
        queryKey: jobArchitectureKeys.skillLimits(architectureId),
        refetchOnWindowFocus: false,
        throwOnError: false,
    });
};
